import Layout from '@/views/layout/Layout'

const fuliRouter = [{
    path: '/fuli',
    component: Layout,
    redirect: '/fuli/index',
    alwaysShow: true,
    meta: { role: "admin", title: '福利社管理', icon: 'example', noCache: true },
    children: [{
        path: 'index',
        name: 'fuli',
        alwaysShow: true,
        component: () => import('@/views/fuli/index'),
        meta: { role: "admin",title: '商品管理', icon: 'form', noCache: true }
    },{
        path: 'edit/id/:id',
        name: 'fuliEdit',
        hidden: true,
        component: () => import('@/views/fuli/edit'),
        meta: { role: "admin",title: '编辑商品', icon: 'form', noCache: false }
    },{
        path: 'manage',
        name: 'welfareManage',
        alwaysShow: true,
        component: () => import('@/views/welfare/manage'),
        meta: { role: "admin",title: '资源位类型', icon: 'form', noCache: true }
    },{
        path: 'resources',
        name: 'welfareResources',
        alwaysShow: true,
        component: () => import('@/views/welfare/resources'),
        meta: { role: "admin",title: '资源位管理', icon: 'form', noCache: true }
    },{
        path: 'manageEdit',
        name: 'welfareManageEdit',
        alwaysShow: true,
        hidden: true,
        component: () => import('@/views/welfare/manageEdit'),
        meta: { role: "admin",title: '新增/编辑', icon: 'form', noCache: true }
    },{
        path: 'edit',
        name: 'welfareEdit',
        alwaysShow: true,
        hidden: true,
        component: () => import('@/views/welfare/edit'),
        meta: { role: "admin",title: '新增/编辑资源位', icon: 'form', noCache: true }
    },
    {
        path: 'order',
        name: 'order',
        alwaysShow: true,
        component: () => import('@/views/order/index'),
        meta: { role: "admin",title: '订单管理', icon: 'form', noCache: false }
    },{
        path: 'statistics',
        name: 'statistics',
        alwaysShow: true,
        component: () => import('@/views/statistics/index'),
        meta: { role: "admin",title: '数据报表', icon: 'form', noCache: false }
    },{
        path: 'classifyManageM',
        name: 'productsClassifyManageM',
        hidden: true,
        component: () => import('@/views/products/classifyManageM'),
        meta: { role: "admin",title: '商品分类管理', icon: 'example', noCache: true }
    },]
}]

 export default fuliRouter



// WEBPACK FOOTER //
// ./src/router/modules/fuliRouter.js